import nj from "numjs"
import { Spinner } from "evergreen-ui"

const memoryBank = {}

export default class RenderCofabComponent extends Component {
  state = { data: null }
  lastTimeStamp = 0
  base = `https://storage.googleapis.com/fls/cofab`

  parseData = data => {
    const serialize = blob => {
      const serialized = {}
      Object.keys(blob).map(key => {
        if (blob[key] && blob[key].__type) {
          serialized[key] = nj.array(blob[key].value)
        } else {
          serialized[key] = blob[key]
        }
      })

      return serialized
    }

    if (Array.isArray(data)) {
      return data.map(serialize)
    }

    return serialize(data)
  }

  getData = async () => {
    const dataFile = `${this.base}/${this.props.folder}/data.json`
    let rawData
    try {
      rawData = await (await fetch(dataFile)).json()
    } catch (err) {
      const text = await (await fetch(dataFile)).text()
      console.log(
        `Cofab: couldn't parse folder ${this.props.folder} with text ${text}`,
      )
      return
    }

    const data = this.parseData(rawData)

    memoryBank[this.props.folder] = data

    this.setState({ data })

    return true
  }

  retry = async () => {
    const statusFile = `${this.base}/${this.props.folder}/status.json`
    const status = await (await fetch(statusFile)).json()

    if (status.timestamp > this.lastTimeStamp) {
      this.lastTimeStamp = status.timestamp
      await this.getData()
    }

    console.log("fetching data for", this.props.folder)
    // setTimeout(this.retry, 1500)
  }

  componentWillMount() {
    const { folder } = this.props
    if (memoryBank[folder]) {
      this.setState({ data: memoryBank[folder] })
    }

    this.retry()
  }

  render() {
    const Component = this.props.component
    const { loadingHeight = 400, loadingEl, additionalProps = {} } = this.props
    let { data } = this.state

    if (data) {
      return <Component data={data} {...additionalProps} />
    }

    if (loadingEl) {
      return loadingEl
    }

    return (
      <Surface
        height={loadingHeight}
        alignSelf="center"
        alignItems="center"
        justifyContent="center"
        alignSelf="center"
      >
        <Spinner />
      </Surface>
    )
  }
}
